import { createContext } from 'react'

interface CacheValueObject {
  [key: string]: CacheValue
}

export type CacheValue =
  | undefined
  | null
  | string
  | number
  | boolean
  | CacheValueObject
  | Array<CacheValue>

type CacheContextType = {
  get: <T extends CacheValue>(key: string) => Promise<T | null>
  set: <T extends CacheValue>(key: string, value: T) => Promise<void>
  clear: () => Promise<void>
}

const cacheContextDefault: CacheContextType = {
  get: () => Promise.resolve(null),
  set: () => Promise.resolve(),
  clear: () => Promise.resolve(),
}

export const CacheContext = createContext<CacheContextType>(cacheContextDefault)
